import React from 'react'

import Chyron, { ChyronSize } from './chyron'

import './speaker-chyron.scss'

interface SpeakerChyronProps {
  name: string
  title?: string
  avatarUrl?: string
}

const SpeakerChyron = ({ name, title, avatarUrl }: SpeakerChyronProps) => {
  return (
    <Chyron size={ChyronSize.Dynamic} kickerPosition="left">
      <div className="speaker-chyron">
        {avatarUrl && <img className="picture" src={avatarUrl} alt="" />}
        <div className="speaker-info">
          <span className="name">{name}</span>
          {title && <span className="title">{title}</span>}
        </div>
      </div>
    </Chyron>
  )
}

export default SpeakerChyron
